import { Icon } from 'ui'
import { CopilotPresetOption } from '../types'

export function iconFromPresetOption(option: CopilotPresetOption): Icon {
    switch (option) {
        case 'copy':
            return 'link'
        case 'delete':
        case 'remove':
            return 'trash'
        case 'duplicate':
            return 'duplicate'
        case 'rename':
            return 'edit'
        case 'update':
            return 'save'
    }
}

export function iconScaleFromPresetOption(option: CopilotPresetOption): number {
    switch (option) {
        case 'delete':
        case 'remove':
        case 'rename':
            return 0.9
        case 'copy':
            return 1.1
        default:
            return 1
    }
}

export function labelFromPresetOption(option: CopilotPresetOption): string {
    switch (option) {
        case 'copy':
            return 'Copy Preset ID'
        case 'delete':
            return 'Delete'
        case 'duplicate':
            return 'Duplicate'
        case 'remove':
            return 'Remove From List'
        case 'rename':
            return 'Rename'
        case 'update':
            return 'Update Preset'
    }
}
